import {
  ADMIN_STATUS,
  CREATIVE_STATUS,
  ModelCreativeRequestFilterInput,
  ModelSortDirection,
} from 'API';
import withApolloProvider from 'hooks/apollo/withApollo';
import {
  GetAdminBrandBriefs,
  GetCreativeUsers,
  GetUsersPaymentDetails,
  UpdateUserTransactions,
} from 'hooks/query/useAdminActions';
import React, { useContext, useEffect } from 'react';
import { ProfileContext } from 'state/profileSteps';
import { UseAdminGetCreativeRequestsByDate } from './useCreativeRequests';

interface HocProps {
  shouldCallApi?: boolean;
}

const CREATIVE_REQUESTS_FILTER: ModelCreativeRequestFilterInput = {
  id: { attributeExists: true },
  creatorId: { attributeExists: true },
  brandBriefId: { attributeExists: true },
  adminApproval: { ne: ADMIN_STATUS.Rejected },
  status: { ne: CREATIVE_STATUS.Rejected },
};

export function withAdmin<T>(
  Component: React.FC<T & HocProps>
): React.FC<T & HocProps> {
  return withApolloProvider((props: T & HocProps) => {
    const { profileState } = useContext(ProfileContext);

    const {
      getRequests: getListCreativeRequests,
      data: creativeRequestsData,
      loading: reqloading,
    } = UseAdminGetCreativeRequestsByDate();
    const {
      getUserPaymentDetails,
      paymentDetails,
      loading: paymentLoading,
    } = GetUsersPaymentDetails();
    const { creativeUsers } = GetCreativeUsers();
    const { updateTransactions } = UpdateUserTransactions();
    const { getListBrandBriefs, brandBriefs } = GetAdminBrandBriefs();

    useEffect(() => {
      getListCreativeRequests({
        variables: {
          limit: 1000,
          type: 'CreativeRequest',
          filter: CREATIVE_REQUESTS_FILTER,
          sortDirection: ModelSortDirection.DESC,
        },
        // FIXME: error policy
        errorPolicy: 'ignore',
      });
    }, []);

    const sortCreativeRequest = async (sort: ModelSortDirection) => {
      await getListCreativeRequests({
        variables: {
          filter: CREATIVE_REQUESTS_FILTER,
          limit: 1000,
          type: 'CreativeRequest',
          sortDirection: sort,
        },
        nextFetchPolicy: 'network-only',
        // FIXME: error policy
        errorPolicy: 'ignore',
      });
    };
    const sortBrandBriefs = (sort: string) => {
      getListBrandBriefs({
        variables: {
          type: 'BrandBrief',
          sortDirection: ModelSortDirection[sort],
        },
      });
    };
    useEffect(() => {
      if (!paymentDetails.length) {
        getUserPaymentDetails();
      }
    }, [getUserPaymentDetails]);

    useEffect(() => {
      getListBrandBriefs({
        variables: {
          type: 'BrandBrief',
          sortDirection: ModelSortDirection.DESC,
        },
      });
    }, []);

    const paymentProps = {
      profileState: { ...profileState },
      creativeRequestsData,
      reqloading,
      brandBriefs: brandBriefs?.items,
      creativeUsers,
      sortCreativeRequest,
      paymentDetails,
      updateTransactions,
      sortBrandBriefs,
      paymentLoading,
    };
    return <Component {...props} {...paymentProps} />;
  });
}
